import $ from 'jquery';

window.$ = $;
window.jQuery = $;

import angular from 'angular';
import angularUiRouter from '@uirouter/angularjs';

require('~/node_modules/bootstrap/dist/css/bootstrap.css');
require('~/node_modules/font-awesome-sass/assets/stylesheets/_font-awesome.scss');
require('~/node_modules/bootstrap-select/dist/css/bootstrap-select.css');
require('~/node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css');
require('~/node_modules/bootstrap-daterangepicker/daterangepicker.scss');
require('~/node_modules/ui-select/dist/select.min.css');
require('~/node_modules/ng-tags-input/build/ng-tags-input.min.css');
require('~/node_modules/angular-bootstrap-toggle/dist/angular-bootstrap-toggle.css');

// core ui dependencies
require('bootstrap');
require('angular-sanitize');
require('ng-tags-input');
require('angular-ui-bootstrap');
require('angular-ui-form-validation');
require('angular-drag-and-drop-lists');
require('bootstrap-select');
require('eonasdan-bootstrap-datetimepicker');
require('bootstrap-daterangepicker');
require('ngstorage');
require('angular-jwt');
require('angular-cache');
require('angular-growl-notifications');
require('angular-ui-tree');
require('ng-error');
require('ng-load');
require('~/node_modules/angular-bootstrap-toggle/dist/angular-bootstrap-toggle.js');
require('~/node_modules/angular-animate/angular-animate.js');
// appspace-ui's package main is components/asui-dist.js, which DECLARES the
// modules below as core.ui dependencies but DEFINES none of them -- they live in
// components/vendor.js, which require('appspace-ui') never loads. Every one of
// core.ui's 15 dependencies must therefore be registered by this app, or the
// whole thing fails to bootstrap with
// [$injector:modulerr] core.ui -> [$injector:nomod] Module '<x>' is not available.
// The rest (ngSanitize, ngAnimate, ngTagsInput, ui.bootstrap, dndLists, ui.tree,
// ngLoad, ngError, growlNotifications, ui.toggle) are required above.
require('angular-aria'); // ngAria
require('angular-translate'); // pascalprecht.translate
require('angular-chart.js'); // chart.js
import flow from '@flowjs/flow.js';
window.Flow = flow;
// Import from moment-timezone, NOT moment: appspace-ui's asui-dist.js calls
// moment(...).tz(...) six times against this global, and bare moment has no .tz
// (moment-timezone is what augments the moment object with it). appspace-ui gets
// moment-timezone via its own dependencies, but require('appspace-ui') only
// loads components/asui-dist.js, so the host app owns this global.
import moment from 'moment-timezone';
window.moment = moment;

// appspace-ui's asui-dist.js CALLS these jQuery plugins but DEFINES none of
// them -- they live in components/vendor.js, the bundle require('appspace-ui')
// never loads -- so each throws "is not a function" the moment its code path
// runs. That is how $.fn.spectrum surfaced, on a colour-picker teardown.
// jquery.ui.position must precede contextMenu, which positions itself with it.
// Guarded by app.module.test.js.
require('spectrum-colorpicker');
require('~/node_modules/jquery-contextmenu/dist/jquery.ui.position.js');
require('~/node_modules/jquery-contextmenu/dist/jquery.contextMenu.js');
require('~/node_modules/velocity-animate/velocity.js');

// The stylesheets those same widgets render against, which went missing with
// vendor.css. Collected in vendorStyles.js so vendorStyles.test.js can assert
// each one still carries its rules -- losing one is otherwise silent until a
// page renders. Required before asui-dist.css below so appspace-ui's own
// overrides continue to win.
require('./vendorStyles');

// appspace ui
require('appspace-ui');
require('~/node_modules/appspace-ui/components/asui-dist.css');

// our first entry point
import appRoot from './app.component';
import licenseModule from './modules/license/license.module';
import supportModule from './modules/support/support.module';
import settingsModule from './modules/settings/settings.module';
import billingModule from './modules/billing/billing.module';
import liveChatModule from './modules/liveChat/liveChat.module';
import sharedModule from './modules/shared/shared.module';
import cloudModule from './modules/cloud/cloud.module';

// Top navigation bar
import asNavBar from './modules/shared/asNavBar/asNavBar.component';

import ngCookies from 'angular-cookies';

export default angular.module('app', [
    appRoot.name,
    // modules
    licenseModule.name,
    supportModule.name,
    settingsModule.name,
    billingModule.name,
    liveChatModule.name,
    sharedModule.name,
    cloudModule.name,
    asNavBar.name,
    // third party dependencies
    'core.ui',
    angularUiRouter,
    ngCookies,
    'ngStorage',
    'asError',
    'angular-jwt',
    'angular-cache',
    'asNotifier',
    'ui.select'
]);



// WEBPACK FOOTER //
// ./app.module.js